import {
  Col,
  Divider,
  Form,
  Modal,
  ModalProps,
  Row,
  Statistic,
  Typography,
} from 'antd';
import InvoiceCFeMethodPayments from '../../InvoiceCFeCreateModal/MethodPayments';
import { useTaxCouponPaymentCreate } from '@/core/domain/coupon/coupons/coupons.hooks';
import { useInvoiceCFEFormContext } from '../../InvoiceCFEFormProvider';
import formatterPrice from '@/utils/number/formatterPrice';

interface Props extends ModalProps {
  onCancel: () => void;
}

const InvoiceCFEPaymentCreateModal: React.FC<Props> = (props) => {
  const [form] = Form.useForm();

  const { taxCoupon } = useInvoiceCFEFormContext();
  const paymentCreate = useTaxCouponPaymentCreate();

  const expensesValues = taxCoupon?.couponItems?.reduce(
    (acc, item) => acc + (item.expenses || 0),
    0,
  );

  const discountValues = taxCoupon?.couponItems?.reduce(
    (acc, item) => acc + (item.discount || 0),
    0,
  );

  const unitaryValues = taxCoupon?.couponItems?.reduce(
    (acc, item) => acc + item.unitValue * item.quantity,
    0,
  );

  const amountValues = taxCoupon?.couponItems?.reduce(
    (acc, item) =>
      acc +
      (item.unitValue * item.quantity -
        (item.expenses || 0) -
        (item.discount || 0)),
    0,
  );

  function handleClose() {
    form.resetFields();
    props.onCancel();
  }

  async function handleSubmit() {
    try {
      const values = await form.validateFields();

      if (taxCoupon) {
        await paymentCreate.mutateAsync({
          payments: values.payments,
          taxCouponId: taxCoupon.id,
        });

        handleClose();
      }
    } catch {}
  }

  return (
    <Modal
      {...props}
      onCancel={handleClose}
      title="Adicionar método de pagamento"
      onOk={handleSubmit}
      okText="Salvar"
      confirmLoading={paymentCreate.isLoading}
    >
      <Form form={form}>
        <Typography.Title level={5}>Valores dos itens</Typography.Title>

        <Row gutter={[16, 16]}>
          <Col span={24} sm={12} md={8} lg={6}>
            <Statistic
              value={formatterPrice(unitaryValues || 0)}
              title="Preço X Qtde."
            />
          </Col>

          <Col span={24} sm={12} md={8} lg={6}>
            <Statistic
              value={formatterPrice(discountValues || 0)}
              title="Desconto"
            />
          </Col>

          <Col span={24} sm={12} md={8} lg={6}>
            <Statistic
              value={formatterPrice(expensesValues || 0)}
              title="Despesas"
            />
          </Col>

          <Col span={24} sm={12} md={8} lg={6}>
            <Statistic
              value={formatterPrice(amountValues || 0)}
              title="Valor total"
            />
          </Col>
        </Row>

        <Divider />

        <InvoiceCFeMethodPayments />
      </Form>
    </Modal>
  );
};

export default InvoiceCFEPaymentCreateModal;
